import { useState } from "react";
import { Lock, AlertCircle } from "lucide-react";
import { Eyebrow } from "./Reveal";
import { api, formatApiError } from "../lib/api";

const inputClass =
    "w-full bg-brand-elevated border border-brand-line rounded px-4 py-3 text-brand-cream text-base placeholder:text-brand-moss focus:outline-none focus:border-brand-amber transition-colors";

const AdminLogin = ({ onSuccess }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            const { data } = await api.post("/auth/login", { email, password });
            onSuccess(data);
        } catch (err) {
            setError(formatApiError(err.response?.data?.detail, "Could not sign in. Try again."));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-md" data-testid="admin-login-panel">
            <Eyebrow className="mb-4">Owner access</Eyebrow>
            <h1 className="font-display font-black uppercase text-brand-cream text-5xl sm:text-6xl tracking-tight leading-[0.92] mb-4">
                Quote <span className="text-brand-amber">inbox.</span>
            </h1>
            <p className="text-brand-sage text-base leading-relaxed mb-10">
                Private page for Southeast Stump Grinding. Sign in to see every
                quote request that's come through the website.
            </p>
            <form onSubmit={submit} className="space-y-4" noValidate>
                <input
                    type="email"
                    autoComplete="username"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className={inputClass}
                    data-testid="admin-login-email"
                    required
                />
                <input
                    type="password"
                    autoComplete="current-password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className={inputClass}
                    data-testid="admin-login-password"
                    required
                />
                {error && (
                    <p
                        className="flex items-start gap-2 text-sm text-[#ff9b7a] bg-[#ff9b7a]/10 border border-[#ff9b7a]/30 rounded px-4 py-3"
                        data-testid="admin-login-error"
                    >
                        <AlertCircle className="w-4 h-4 shrink-0 mt-0.5" />
                        {error}
                    </p>
                )}
                <button
                    type="submit"
                    disabled={loading}
                    data-testid="admin-login-submit"
                    className="w-full inline-flex items-center justify-center gap-3 bg-brand-amber text-brand-ink font-bold text-lg px-8 py-4 rounded-full hover:bg-brand-amberHover transition-colors disabled:opacity-60"
                >
                    <Lock className="w-5 h-5" />
                    {loading ? "Signing in..." : "Sign in"}
                </button>
            </form>
        </div>
    );
};

export default AdminLogin;
